import { IImageFullWidth } from '@models/IImageFullWidth';
import ImageLightBox from '@molecules/ImageLightBox/ImageLightBox';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import classNames from 'classnames';

const ImageFullWidth = (props: IImageFullWidth) => {
  // These props were null checked because this was causing an issue with the LocationMap Markers
  // not showing locally, even though this component was not added to the LocationMap page.
  // At some point it is worth checking this over and include the props as per other components
  const {
    anchorId = '',
    subTitle,
    title,
    meta,
    showImageOnTop,
    ...rest
  } = props ?? {};

  return (
    <section
      id={`a-${anchorId}`}
      className="layout component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-07-Image-Full-Width"
    >
      <SoftLoadWrapper>
        <div
          className={classNames(
            'inner flex gap-7.5 two-col:px-0 xl:gap-[50px]',
            {
              'flex-col': showImageOnTop,
              'flex-col-reverse': !showImageOnTop,
            }
          )}
        >
          <ImageLightBox
            {...rest}
            imageClasses="h-full w-full"
            contentIds={meta?.contentLink ? [meta.contentLink as string] : []}
            dataTestId="CT-07-Image-Full-Width-Lightbox"
          />

          {(subTitle || title) && (
            <div className="xl:grid xl:grid-cols-12">
              <div className="flex flex-col gap-5 xl:col-span-6 xl:col-start-2">
                {title && (
                  <h2 className="h3" data-testid="CT-07-Image-Full-Width-Title">
                    {title}
                  </h2>
                )}
                {subTitle && (
                  <p
                    className="body-two text-grey-450 dark:text-grey-500"
                    data-testid="CT-07-Image-Full-Width-Subtitle"
                  >
                    {subTitle}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};
export default ImageFullWidth;
